var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", position: "relative" } },
    [
      _c("view-track-bar", {
        ref: "viewTrack",
        staticClass: "track-bar",
        style: _vm.trackBarStyleTime,
        attrs: { "track-menu": _vm.trackMenu },
        on: { trackClick: _vm.trackClick },
      }),
      _c("div", {
        staticStyle: { width: "100%", height: "100%", overflow: "hidden" },
        style: { borderRadius: _vm.borderRadius },
        attrs: { id: _vm.chartId },
      }),
      _vm.chart.type === "map" && _vm.showSuspension
        ? _c("map-controller", {
            attrs: {
              chart: _vm.chart,
              "button-text-color": _vm.buttonTextColor,
            },
            on: { "roam-map": _vm.roamMap, "reset-zoom": _vm.resetZoom },
          })
        : _vm._e(),
      _c("div", {
        class: _vm.loading ? "symbol-map-loading" : "symbol-map-loaded",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }